import { render, staticRenderFns } from "./StudioProductGenre.vue?vue&type=template&id=0057fc39&scoped=true&"
import script from "./StudioProductGenre.vue?vue&type=script&lang=js&"
export * from "./StudioProductGenre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0057fc39",
  null
  
)

export default component.exports